<template>
  <div id="store-info" class="content-section">
    <div class="section-title">门店信息</div>
    <div class="section-content" v-loading="loading">
      <QSCommonTable
        :loading="loading"
        :data="tableData"
        :columns="colList"
        row-key="id"
        :pagination="false"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { use$to } from '@/utils/useUtils'
import { storeList } from '@/api/domain/shop'

const $to = use$to()

const props = defineProps({
  storeIds: {
    type: Array,
    default: () => [],
  },
})

const tableData = ref([])
const loading = ref(false)

// 表格列配置
const colList = computed(() => {
  return [
    {
      name: 'id',
      columnProps: {
        prop: 'id',
        label: '门店ID',
      },
    },
    {
      name: 'name',
      columnProps: {
        prop: 'name',
        label: '门店名称',
      },
    },
    {
      name: 'address',
      columnProps: {
        prop: 'address',
        label: '门店地址',
      },
    },
    {
      name: 'contactTel',
      columnProps: {
        prop: 'contactTel',
        label: '联系方式',
      },
    },
  ]
})
const getTableData = async () => {
  if (!props.storeIds?.length || loading.value) return
  loading.value = true
  const [err, res] = await $to(
    storeList({
      storeIds: props.storeIds,
    }),
  )
  loading.value = false
  if (err || res?.code !== 1) return
  const { items = [] } = res.data
  tableData.value = items
}

watch(
  () => props.storeIds,
  () => {
    getTableData()
  },
)
</script>

<style lang="scss" scoped>
.content-section {
  background: #ffffff;
  border-radius: 12px;
  opacity: 1;
  margin-bottom: 12px;

  .section-title {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    padding: 8px 16px;
    line-height: 24px;
    letter-spacing: 0em;
    color: rgba(0, 0, 0, 0.9);
  }

  .section-content {
    padding: 0 16px 16px 16px;
  }
}

:deep(.el-table) {
  border-radius: 4px;

  th {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 500;
    padding: 12px 0;
  }

  td {
    padding: 12px 0;
    color: #606266;
  }

  .column-header-with-icon {
    display: flex;
    align-items: center;
    justify-content: center;

    .example-tag {
      margin-left: 8px;
      background-color: #f0f5ff;
      color: #366cfe;
      border-color: #d9e8ff;
      font-size: 12px;
      padding: 0 6px;
      height: 20px;
      line-height: 18px;

      i {
        margin-right: 2px;
      }
    }
  }
}
</style>
